// extracted by mini-css-extract-plugin
export default {"Markdown":"Markdown__Markdown___F2O0_"};